import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
const OrderLineViewTable = ({ formData, handleFieldChange, isOrderLineTabBold }) => {
    const dispatch = useAppDispatch();
    const [gridCalculations, setGridCalculations] = useState();
    const { calculations } = useAppSelector((state) => state.calculation);
    const { SelectedWorkorderCalculationsToOrderItemIdsList } = useAppSelector((state) => state.order);
    // useEffect(() => {
    //     if (SelectedWorkorderCalculationsToOrderItemIdsList == null) {
    //         dispatch(getAllCalculationsByWorkOrderIDAsync(formData.workorderId)).unwrap().then((res) => {
    //             handleFieldChange('calculations', null);
    //             var calculationList=calculations?.filter(x=>x.unit!="Uren");
    //             setGridCalculations(calculationList);
    //             if(isOrderLineTabBold && calculationList && calculationList?.length>0){
    //                 isOrderLineTabBold(true)
    //             }
    //             else{
    //                 isOrderLineTabBold && isOrderLineTabBold(false)
    //             }
    //         });
    //     }
    // }, [formData.workorderId, calculations]);
    // useEffect(() => {
    //     if (SelectedWorkorderCalculationsToOrderItemIdsList) {
    //         setGridCalculations(SelectedWorkorderCalculationsToOrderItemIdsList);
    //         handleFieldChange('calculations', SelectedWorkorderCalculationsToOrderItemIdsList);
    //         if(isOrderLineTabBold && SelectedWorkorderCalculationsToOrderItemIdsList.length>0){
    //             isOrderLineTabBold(true)
    //         }
    //         else{
    //             isOrderLineTabBold && isOrderLineTabBold(false)
    //         }
    //         dispatch(clearSelectedWorkorderCalculationToOrderItemsList());
    //     }
    // }, [SelectedWorkorderCalculationsToOrderItemIdsList]);
    // Helper to get dataKey from URL
    const getDataKeyFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('dataKey');
    };
    useEffect(() => {
        const dataKey = getDataKeyFromUrl();
        if (dataKey) {
            const dataString = localStorage.getItem(dataKey);
            if (dataString) {
                try {
                    const data = JSON.parse(dataString);
                    // Check if not expired (1 hour)
                    if (Date.now() - data.timestamp < 3600000) {
                        const calculationList = data.selectedCalculations?.filter((x) => x.unit !== 'Uren') || [];
                        setGridCalculations(calculationList);
                        handleFieldChange('calculations', calculationList);
                        if (isOrderLineTabBold) {
                            isOrderLineTabBold(calculationList.length > 0);
                        }
                    }
                    else {
                        // Data expired, remove from storage
                        localStorage.removeItem(dataKey);
                        setGridCalculations([]);
                        handleFieldChange('calculations', null);
                        if (isOrderLineTabBold)
                            isOrderLineTabBold(false);
                    }
                }
                catch {
                    setGridCalculations([]);
                    handleFieldChange('calculations', null);
                    if (isOrderLineTabBold)
                        isOrderLineTabBold(false);
                }
            }
            else {
                setGridCalculations([]);
                handleFieldChange('calculations', null);
                if (isOrderLineTabBold)
                    isOrderLineTabBold(false);
            }
        }
    }, [formData.workorderId]);
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'custom-table-container mt-5', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-order-line-main', children: _jsxs("table", { className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", { children: _jsx("span", { className: 'header-caption', children: "#" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Werkorder" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Artikel nr" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Naam" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Merk" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Type" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Gegevens" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Artikelnr Leverancier" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Aantal" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Totaalbedrag(\u20AC)" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: gridCalculations &&
                                    gridCalculations?.map((calculation, index) => (_jsxs("tr", { style: { cursor: 'pointer' }, children: [_jsx("td", { className: 'pt-4', children: _jsx("span", { children: index + 1 }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.workOrderNumber }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.articleNumber }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.name }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.brand }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.type }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.data }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.supplierArticleNumber }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: calculation.quantity?.toLocaleString('de-DE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }) }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: (calculation.quantity * calculation.netPrice)?.toLocaleString('de-DE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }) }) })] }, calculation.id))) })] }) }) }) }) }));
};
export default OrderLineViewTable;
